<template>
  <el-dialog
    title="控制面板"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="45%"
  >
    <el-table
      :data="tableData"
      style="width: 100%"
      :span-method="objectSpanMethod"
    >
      <el-table-column prop="title" label="属性"></el-table-column>
      <el-table-column label="值">
        <template slot-scope="scope">
          <div v-html="scope.row.name"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="absolute" v-if="scope.$index === 0">
            <div>
              <el-button type="primary" @click="resetMachine()"
                >重置/停止机器</el-button
              >
            </div>
            <div>
              <el-button type="success" @click="startMachine()"
                >远程启动</el-button
              >
            </div>
            <div v-if="ruleForm.machineEnable">
              <el-button type="info" @click="disableMachine('禁用机器', false)"
                >禁用机器</el-button
              >
            </div>
            <div v-else>
              <el-button type="danger" @click="disableMachine('启用机器', true)"
                >启用机器</el-button
              >
            </div>
            <div>
              <el-button type="warning" @click="refreshMachine()"
                >刷新状态</el-button
              >
            </div>
            <div v-if="ruleForm.machineSystem != ''">
              <el-button type="danger" @click="setMachineSystem()"
                >设置为 {{ ruleForm.machineSystem }}
              </el-button>
            </div>
            <div>
              <el-button type="primary" @click="initMachineSystemBeiEr()"
                >初始化盒子</el-button
              >
            </div>
            <el-select v-model="productid" placeholder="请选择产品发送指令">
              <el-option
                v-for="(item, index) in ProductsList"
                :key="index"
                :label="item.name"
                :value="item.productid"
              ></el-option>
            </el-select>
            <div>
              <el-button type="primary" @click="sendProductCommand()"
                >发送产品指令</el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import enumObject from "../../../plugins/enum";
export default {
  props: {
    machineInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ruleForm: {
        id: this.machineInfo ? this.machineInfo.id : 0,
        machineid: this.machineInfo ? this.machineInfo.machineid : "",
        machineType: this.machineInfo ? this.machineInfo.machineType : "",
        machineModel: this.machineInfo ? this.machineInfo.machineModel : "",
        machineSystem: this.machineInfo ? this.machineInfo.machineSystem : "",
        machineName: this.machineInfo ? this.machineInfo.machineName : "",
        machineCodeInShop: this.machineInfo
          ? this.machineInfo.machineCodeInShop
          : "",
        machineStatus: this.machineInfo ? this.machineInfo.machineStatus : "",
        machineLeftTime: this.machineInfo.machineLeftTime,
        machineEnable: this.machineInfo
          ? this.machineInfo.machineEnable
          : undefined,
        lastOfflineTime: "-"
      },
      productid: "",
      ProductsList: []
    };
  },
  methods: {
    initData() {
      this.ruleForm = {
        id: this.machineInfo ? this.machineInfo.id : 0,
        machineid: this.machineInfo ? this.machineInfo.machineid : "",
        machineType: this.machineInfo ? this.machineInfo.machineType : "",
        machineModel: this.machineInfo ? this.machineInfo.machineModel : "",
        machineName: this.machineInfo ? this.machineInfo.machineName : "",
        machineCodeInShop: this.machineInfo
          ? this.machineInfo.machineCodeInShop
          : "",
        machineStatus: this.machineInfo ? this.machineInfo.machineStatus : "",
        machineLeftTime: this.machineInfo.machineLeftTime,
        machineEnable: this.machineInfo
          ? this.machineInfo.machineEnable
          : undefined
      };
    },
    disableMachine(text, param) {
      var r = confirm(`确定${text}？`);
      if (r) {
        this.$axios(this.$urlMapping["编辑机器"], {
          data: {
            id: this.ruleForm.id,
            machineEnable: param
          }
        }).then(() => {
          this.$notifySuccess();
          this.$nextTick(() => {
            this.refreshMachine();
          });
        });
      }
    },
    startMachine() {
      var r = confirm("确定启动机器？");
      if (r) {
        this.$axios(this.$urlMapping["操作机器"], {
          data: {
            machineid: this.ruleForm.machineid,
            operation: "start"
          }
        }).then(() => {
          this.$notifySuccess();
          this.$nextTick(() => {
            this.refreshMachine();
          });
        });
      }
    },
    resetMachine() {
      var r = confirm("确定重启机器？");
      if (r) {
        this.$axios(this.$urlMapping["操作机器"], {
          data: {
            machineid: this.ruleForm.machineid,
            operation: "reset"
          }
        }).then(() => {
          this.$notifySuccess();
          this.$nextTick(() => {
            this.refreshMachine();
          });
        });
      }
    },

    sendProductCommand() {
      var r = confirm("确定发送该产品的指令？");
      if (r) {
        console.log(this.ruleForm.machineid);
        console.log(this.productid);
        if (this.productid == "") {
          return;
        }

        this.$axios(this.$urlMapping["发送产品指令"], {
          data: {
            machineid: this.ruleForm.machineid,
            productid: this.productid
          }
        }).then(() => {
          this.$notifySuccess();
          this.$nextTick(() => {
            this.refreshMachine();
          });
        });
      }
    },

    setMachineSystem() {
      var r = confirm(
        "确定要设置" + this.ruleForm.machineSystem + "协议？（盒子会重启）"
      );
      if (r) {
        this.$axios(this.$urlMapping["设置协议"], {
          data: {
            machineid: this.ruleForm.machineid,
            machineSystem: this.ruleForm.machineSystem
          }
        }).then(() => {
          this.$notifySuccess();
        });
      }
    },
    initMachineSystemBeiEr() {
      var r = confirm(
        "确定初始化" + this.ruleForm.machineid + "盒子？"
      );
      if (r) {
        this.$axios(this.$urlMapping["初始化盒子"], {
          data: {
            machineid: this.ruleForm.machineid
          }
        }).then(() => {
          this.$notifySuccess();
        });
      }
    },
    refreshMachine() {
      this.$axios(this.$urlMapping["查询机器"], {
        data: {
          machineid: this.ruleForm.machineid
        }
      }).then(result => {
        if (result.data.length === 1) {
          this.$emit("refreshMachine", result.data[0].machineExtendModel);
          this.$nextTick(() => {
            this.initData();
          });
          this.$notifySuccess();
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    },
    objectSpanMethod({ columnIndex }) {
      if (columnIndex === 2) {
        return {
          rowspan: 7,
          colspan: 1
        };
      }
    }
  },
  computed: {
    CITY_ENUM() {
      return enumObject.CITY_ENUM.filter(ele => ele.value !== "");
    },
    MACHINE_STATUS_ENUM() {
      return enumObject.MACHINE_STATUS_ENUM.filter(ele => ele.value !== "");
    },
    filterShopList() {
      return this.shopList.filter(
        ele => ele.shopOwner === this.ruleForm.vendorid
      );
    },
    tableData() {
      return [
        {
          title: "机器ID",
          name: this.ruleForm.machineid
        },
        {
          title: "机器类型",
          name: this.ruleForm.machineType
        },
        {
          title: "机器型号",
          name: this.ruleForm.machineModel
        },
        {
          title: "机器硬件协议类型",
          name: this.ruleForm.machineSystem
        },
        {
          title: "机器名称",
          name: this.ruleForm.machineName
        },
        {
          title: "店内编号",
          name: this.ruleForm.machineCodeInShop
        },
        {
          title: "机器状态",
          name: this.MACHINE_STATUS_ENUM.find(
            ele => ele.value === this.ruleForm.machineStatus
          )
            ? this.MACHINE_STATUS_ENUM.find(
                ele => ele.value === this.ruleForm.machineStatus
              ).label
            : ""
        },
        {
          title: "剩余时间",
          name:
            Math.floor(this.ruleForm.machineLeftTime / 60) +
            "分" +
            (this.ruleForm.machineLeftTime % 60) +
            "秒"
        },
        {
          title: "是否可用",
          name: this.ruleForm.machineEnable
            ? '<i class="el-icon-check" style="color:#67c23a;font-weight:bold;"></i>'
            : '<i class="el-icon-close" style="color:#e66100;font-weight:bold;"></i>'
        },
        {
          title: "最近离线时间",
          name: this.ruleForm.lastOfflineTime
        }
      ];
    }
  },
  mounted() {
    this.$axios(
      this.$urlMapping["机器的产品"] + "?machineid=" + this.ruleForm.machineid,
      {
        data: {}
      }
    ).then(result => {
      this.ProductsList = result.data;
      console.log(this.ProductsList);
    });

    this.$axios(this.$urlMapping["查询离线"], {
      data: {
        machineid: this.ruleForm.machineid,
        pageSize: 1,
        pageNum: 1
      }
    }).then(result => {
      console.log(result);
      if (result.data && result.data.length > 0) {
        this.ruleForm.lastOfflineTime = result.data[0].createtime.replace(
          "T",
          " "
        );
      }
    });
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}

.absolute {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // 提升层级，避免鼠标悬浮时表格单元格的高亮背景遮挡按钮
  z-index: 10;
  & > div {
    margin-top: 12px;
  }
}
</style>
